import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {MasterService} from '../../../services/master.service';
import {LoaderProvider} from '../../../utils/providers/loader-provider';
import {finalize} from 'rxjs/operators';

@Component({
  selector: 'app-requeriment-change-status',
  templateUrl: './requeriment-change-status.component.html',
  styleUrls: ['./requeriment-change-status.component.scss']
})
export class RequerimentChangeStatusComponent implements OnInit, AfterViewInit {
  @Input() requirementStatus: {id?: number, commentDetail?: { comment?: string }, idStatus?: number};
  requirementForm: FormGroup;
  availableStatus = [];

  constructor(
    private fb: FormBuilder,
    private activeModal: NgbActiveModal,
    private masterService: MasterService,
    private loader: LoaderProvider,
  ) {
  }

  ngOnInit(): void {
    this.createForm();
    this.getStatusTags();
  }

  ngAfterViewInit(): void {
    this.updateForm();
  }

  getStatusTags(): any {
    this.masterService.getRequirementClaimtags()
      .subscribe( res => {
        this.availableStatus = res;
      });
  }

  sendData(): any {
    const dataToSend = {
      ...this.requirementForm.value,
    };

    this.activeModal.close(dataToSend);
  }

  private createForm(): any {
    this.requirementForm = this.fb.group({
      id: ['', Validators.required],
      comment: [this.requirementStatus.commentDetail[0].comment || '', Validators.required],
      statusId: [this.requirementStatus.idStatus || '', Validators.required],
    });
  }

  private updateForm(): any {
    this.requirementForm.get('id').setValue(this.requirementStatus.id);
  }

}
